// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  lottieConfig: string,
  children: React.ChildrenArray<React.Node>
};
@computeData()
export default class Lottie extends React.PureComponent<Props> {
  lottieBox: any;
  static schema: PropsSchema = [
    {
      title: 'lottie参数',
      key: 'lottieConfig',
      type: 'code'
    },
    'separator',
    {
      type: 'style'
    }
  ];

  constructor (props: Props) {
    super(props)
    this.lottiePromise = import('lottie-web').then(lottie => {
      return lottie
    })
  }

  lottiePromise: Promise<*>;

  componentDidMount () {
    const { lottieConfig, jsEnv } = this.props
    const lottieConfigObj = jsEnv.runCode(lottieConfig)
    this.lottiePromise.then(lottie => {
      lottie.loadAnimation({
        container: this.lottieBox,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path:
          'https://ms.fengjr.com/mobile-web/source/2019/05/LottieLogo2.json',
        ...lottieConfigObj
      })
    })
  }

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style } = this.props
    return (
      <div
        id={id}
        style={style}
        ref={ref => {
          this.lottieBox = ref
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Lottie.js